b247.cta = function() {

}

$('[data-membershipmodule]').on('click', function (e) {
  
	e.preventDefault();

	window.dataLayer.push({
		'event': 'event-to-ga',
		'eventCategory' : $(this).data('member-ga-category'),
		'eventAction' : $(this).data('member-ga-action'),
		'eventLabel' : $(this).data('member-ga-label')
	});

	window.open( $(this).attr('href'), '_blank' );

});